export default __webpack_public_path__ + "static/usa_colorado_lotto-34ef9bb966b7465bea78dfd7d04e6614.png";